import { render, staticRenderFns } from "./RichTextEditor.vue?vue&type=template&id=7550b94f&"
import script from "./RichTextEditor.vue?vue&type=script&lang=js&"
export * from "./RichTextEditor.vue?vue&type=script&lang=js&"
import style0 from "./RichTextEditor.vue?vue&type=style&index=0&id=7550b94f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports